import { render, staticRenderFns } from "./invoiceApplyList.vue?vue&type=template&id=1636bf96&scoped=true"
import script from "./invoiceApplyList.vue?vue&type=script&lang=js"
export * from "./invoiceApplyList.vue?vue&type=script&lang=js"
import style0 from "./invoiceApplyList.vue?vue&type=style&index=0&id=1636bf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636bf96",
  null
  
)

export default component.exports